module.exports = __webpack_public_path__ + "static/oduwole-56cd382a5fe5faa34764bf6e1dd5d9a0.jpg";